import FiltersTracker from './filters';
import DirectorySortingTracker from './sorting';
import TagsTracker from './tags';
import DirectoryThumbnailTracker from './thumbnails';
import SegmentedDirectoryTracker from './segmented';


export const filtersTracker = new FiltersTracker();
export const directorySortingTracker = new DirectorySortingTracker();
export const tagsTracker = new TagsTracker();
export const directoryThumbnailTracker = new DirectoryThumbnailTracker();
export const segmentedDirectoryTracker = new SegmentedDirectoryTracker();
